<template>
  <div id="dashboard-statistics">
    <div class="vx-row">
      <!-- CARD 2: График с лидами -->
      <div class="vx-col w-full mb-base">
        <vx-card slot="no-body" class="text-center shadow-card">
          <div v-if="hasGraph" slot="no-body" class="flex flex-wrap">
            <div class="flex px-6 flex-wrap pt-6 mx-2 items-center w-full">
              <h2 class="text-lg font-semibold leading-28">
                Лиды
              </h2>
              <cluster-select
                v-if="selects.complexesData.length > 1"
                v-model="selects.leadsComplex"
                class="ml-auto"
                :data="selects.complexesData"
                @change="getData"
                @getLabel="getComplexLabel"
              />
              <p v-else class="ml-auto">
                {{ userInfo.name }}
              </p>
              <div
                class="cluster-select ml-6 ce-select w-220px"
                :class="{ 'cluster-select--open': calendarModal.isShow && !calendarModal.isViews }"
                @click.stop="openCalendarModal"
              >
                <input class="cluster-select__input cursor-pointer" :value="calendarModal.leadsLabel">
                <i-arrow-bottom class="cluster-select__icon" />
              </div>
            </div>
            <div class="flex px-6 flex-col w-full pt-2 bg-white" data-v-step="2">
              <div class="flex flex-wrap mx-2 w-full">
                <div
                  v-for="(item, index) in leads.statistic"
                  :key="index"
                  class="mr-6 flex flex-col items-start"
                  :class="item.class"
                >
                  <p class="text-grey text-13 leading-20">
                    {{ item.text }}
                  </p>
                  <span
                    :class="['h:24', { 'font-semibold': item.isBold }, item.isSmall ? 'text-base' : 'text-2xl']"
                    :style="{ lineHeight: '28px' }"
                    :title="item.tooltip"
                  >
                    {{ item.value }}
                  </span>
                </div>
                <vs-button
                  size="small"
                  class="text-sm self-center"
                  @click="$store.commit('help/POPUP_REFILL', selects.complexName)"
                >
                  Пополнить
                </vs-button>
              </div>

              <vue-apex-charts
                style="margin-left: -10px;"
                type="line"
                height="266"
                class="w-full"
                :options="chartData.leads.chartOptions"
                :series="leads.chartSeries"
              />
            </div>
          </div>
          <h2 v-else class="p-6 text-lg text-center font-semibold leading-28">
            Данных по статистике пока нет
          </h2>
        </vx-card>
      </div>
    </div>

    <!-- CARD 3: График с просмотрами -->
    <!-- TODO: нужен бэк -->
    <div v-if="false" class="vx-row">
      <div class="vx-col w-full lg:w-12/12 mb-base">
        <vx-card slot="no-body" class="text-center shadow-card" data-v-step="3">
          <div slot="no-body" class="p-6 pb-0">
            <div class="flex flex-wrap mx-2 mb-2 items-center">
              <h2 class="text-lg font-semibold leading-28">
                Просмотры
              </h2>
              <cluster-select
                v-if="selects.complexesData.length > 1"
                v-model="selects.viewsComplex"
                class="ml-auto"
                :data="selects.complexesData"
              />
              <p v-else class="ml-auto">
                {{ userInfo.displayName }}
              </p>
              <div
                class="cluster-select ml-6 ce-select w-220px"
                :class="{ 'cluster-select--open': calendarModal.isShow && calendarModal.isViews }"
                @click.stop="openCalendarModal($event, true)"
              >
                <input class="cluster-select__input cursor-pointer" :value="calendarModal.viewsLabel">
                <i-arrow-bottom class="cluster-select__icon" />
              </div>
            </div>
            <div class="flex mx-2 items-center">
              <div
                v-for="(item, index) in views.statistic"
                :key="index"
                class="mr-6 flex flex-col items-start"
                :class="item.class"
              >
                <p class="text-grey text-13 leading-20">
                  {{ item.text }}
                </p>
                <span class="text-2xl" :class="{ 'font-semibold': item.isBold }">{{ item.value }}</span>
              </div>
            </div>

            <vue-apex-charts
              style="margin-left: -10px;"
              type="line"
              height="266"
              :options="chartData.views.chartOptions"
              :series="chartData.views.series"
            />
          </div>
        </vx-card>
      </div>
    </div>
    <calendar-modal
      :option="calendarModal.isViews ? calendarModal.viewsOption : calendarModal.leadsOption"
      :position="calendarModal.position"
      :is-show="calendarModal.isShow"
      @change="selectDate"
      @toggle="toggleCalendarModal"
    />
    <v-tour
      v-if="steps.length"
      name="tutorial"
      :steps="steps"
      :callbacks="{ onStart: tutorialOverlayOpen, onStop: tutorialOverlayClose }"
      :options="{ highlight: true }"
    >
      <template slot-scope="tour">
        <transition name="fade">
          <!--eslint-disable-->
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :highlight="tour.highlight"
            :labels="tour.labels"
          >
            <!--eslint-enable-->
            <template>
              <div slot="actions">
                <vs-button class="text-sm w-160px" size="small" @click="tutorialNextStep(tour)">
                  {{ step.btnText }}
                </vs-button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import VueApexCharts from 'vue-apexcharts';

import { checkCookie, setCookie } from '@/utils/cookie';
import CalendarModal from '@/components/calendar/CalendarModal.vue';
import ClusterSelect from '@/components/ClusterSelect.vue';
import IArrowBottom from '@/assets/svg/icons/arrow-small-bottom.svg';

import chartData from './chartSettings';

export default {
  components: {
    VueApexCharts,
    CalendarModal,
    ClusterSelect,
    IArrowBottom,
  },
  data() {
    return {
      chartData,
      hasGraph:      false,
      calendarModal: {
        isShow:      false,
        isViews:     false,
        position:    {},
        leadsOption: 0,
        leadsLabel:  'Последние 30 дней',
        viewsOption: 0,
        viewsLabel:  'Последние 30 дней',
      },
      selects: {
        leadsComplex:  0,
        leadsDate:     [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        viewsComplex:  0,
        viewsDate:     [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        complexesData: [{ value: 0, label: 'Все ЖК' }],
        complexName:   '',
      },
      leads: {
        chartSeries: [{
          name: 'Лиды',
          data: [],
        }],
        statistic: [
          {
            text:   'Всего пришло',
            value:  0,
            isBold: true,
          },
          {
            text:  'Звонки',
            value: 0,
          },
          {
            text:  'Заявки',
            value: 0,
            class: 'mr-auto',
          },
          {
            text:  'Осталось бонусов',
            value: 0,
          },
          {
            text:    'Осталось лидов',
            value:   0,
            isBold:  true,
            tooltip: true,
          },
        ],
      },
      views: {
        statistic: [
          {
            text:   'Всего',
            value:  0,
            isBold: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    /**
     * Шаги для онбординга
     *
     * @return {Array<Object>}
     */
    steps() {
      const steps = [];

      if (this.hasGraph) {
        steps.push({
          header: {
            title: 'Следите за лидами',
          },
          target:  '[data-v-step="2"]',
          btnText: 'Понятно',
          content: 'Контролируйте баланс оставшихся лидов и поступление заявок',
          params:  {
            enableScrolling: false,
            placement:       'bottom',
          },
        });
      }

      return steps;
    },
  },
  created() {
    this.selects.complexesData = this.setComplexData();
    this.setSelectedComplex();
    this.getData();
  },
  beforeDestroy() {
    if (this.$tours.tutorial) {
      this.$tours.tutorial.stop();
    }
  },
  methods: {
    /**
     * Возврашает изначачльные данные ЖК зависимости от роли юзера
     * Этот костыль нужен из-за специфичности бэккенда
     *
     * @todo улучшить backend, пересмотреть архитектуру
     * @return {Object[]}
     */
    setComplexData() {
      return this.userInfo.userRole === 'complex'
        ? [{ value: this.userInfo.id, label: this.userInfo.name }]
        : [{ value: 0, label: 'Все ЖК' }];
    },

    /**
     * Если юзер ЖК. то поставляем его id в selects.leadsComplex, чтобы на бэк отправился сразу нужный ЖК
     * Этот костыль нужен из-за специфичности бэккенда
     *
     * @todo улучшить backend, пересмотреть архитектуру
     */
    setSelectedComplex() {
      if (this.userInfo.userRole === 'complex') {
        this.selects.leadsComplex = this.userInfo.id;
        this.selects.complexName = this.userInfo.name;
      }
    },

    /**
     * Получить данные из Backend
     */
    getData() {
      this.$vs.loading({ scale: 1 });

      this.$http.get('cabinet/requests/stats', {
        params: {
          range:     this.selects.leadsDate,
          agentList: this.userInfo.userRole !== 'complex' ? 1 : 0,
          ...(this.selects.leadsComplex && { ids: this.selects.leadsComplex }),
          ...(this.userInfo.userRole === 'builder' && { builderId: this.userInfo.passportId }),
        },

      })
        .then(({ data: { data } }) => {
          if (data.agents) {
            const rows = [];

            // eslint-disable-next-line no-restricted-syntax
            for (const [value, label] of Object.entries(data.agents)) {
              rows.push({ value, label });
            }

            this.selects.complexesData = [...this.setComplexData(), ...rows];
          }

          // @todo: улучшить метод в next iterration
          const formattedDate = [];
          const hasLeadsComplex = Boolean(this.selects.leadsComplex);
          const staticPlacement = data.listStaticPlacement ?? {};
          const isStatic = hasLeadsComplex
            ? (this.selects.complexesData || []).every((item) => staticPlacement[item?.value])
            : false;

          if (data.diagramList.length) {
            this.hasGraph = true;
          }

          for (let i = 0; i < data.diagramList.length; i++) {
            const { date, count } = data.diagramList[i];
            formattedDate.push({ y: count, x: dayjs(date).format('YYYY-MM-DD') });
          }

          const sumArray = Object.values(formattedDate.reduce((a, { x, y }) => {
            a[x] = (a[x] || { x, y: 0 });
            a[x].y += y;
            return a;
          }, {}));

          sumArray.sort((a, b) => {
            const dateA = new Date(a.x);
            const dateB = new Date(b.x);
            return dateA - dateB;
          });

          this.leads.chartSeries = [{
            data: sumArray,
          }];

          this.leads.statistic[0].value = data.totalCount;
          this.leads.statistic[1].value = data.callCount;
          this.leads.statistic[2].value = data.formCount;
          this.leads.statistic[3].value = data.bonusLeadsCount;
          this.leads.statistic[4].value = '∞';
          this.leads.statistic[4].tooltip = data.leadsCount;
          this.leads.statistic[4].isBold = !isStatic;
          this.leads.statistic[4].isSmall = isStatic;
        }).finally(() => {
          this.$vs.loading.close();

          if (!checkCookie('stats_tutorial') && this.$tours.tutorial) {
            this.$tours.tutorial.start();
          }
        });
    },

    /**
     * Открытие / Закрытие модалки календарая
     *
     * @param {Boolean} bool
     */
    toggleCalendarModal(bool) {
      this.calendarModal.isShow = bool;
    },

    /**
     * Открыть календарь. Нужен чтобы передать откуда был вызов и позиция для модалки
     *
     * @param {Event} event - Определим позицию, откуда был вызван
     * @param {Boolean} [isViews] - Календарь для карточки просмотры
     */
    openCalendarModal(event, isViews = false) {
      const e = event.target || event.srcElement;
      const { right, bottom } = e.getClientRects()[0];
      this.calendarModal.isViews = isViews;
      this.calendarModal.position = {
        right: `${document.body.offsetWidth - right}px`,
        top:   `${bottom + 8}px`,
      };
      this.calendarModal.isShow = true;
    },

    /**
     * Задает название выбранного ЖК. Нужен для модалки помощи
     *
     * @param {String} name - название ЖК
     */
    getComplexLabel(name) {
      this.selects.complexName = name !== 'Все ЖК' ? name : '';
    },

    /**
     * Выбираем дату в фильтре и вызываем метод getRequests
     *
     * @param {String[]} date - Дата от и до
     * @param {Number} option - Какая опция была выбрана
     * @param {String} label - Какой текст отображать в фильтре
     */
    selectDate(date, option, label) {
      const { isViews } = this.calendarModal;

      this.selects[isViews ? 'viewsDate' : 'leadsDate'] = date;
      this.calendarModal[isViews ? 'viewsOption' : 'leadsOption'] = option;
      this.calendarModal[isViews ? 'viewsLabel' : 'leadsLabel'] = label;

      if (!isViews) this.getData();
    },

    /**
     * Включает overlay при открытие обучение
     */
    tutorialOverlayOpen() {
      this.$store.commit('TUTORIAL_OVERLAY_TOGGLE', true);
      window.scrollTo(0, 0);
    },

    /**
     * Выключает overlay при окончание обудчение, и проставливает куку на 61 сутки (2 месяца)
     */
    tutorialOverlayClose() {
      this.$store.commit('TUTORIAL_OVERLAY_TOGGLE', false);

      setCookie('stats_tutorial', 1, { expires: 61 });
    },

    /**
     * Переключает на следюущий шаг при обучений. Если полсдений шаг. то останавливает обучение
     *
     * @param {Object} tour - состояние обучение
     */
    tutorialNextStep(tour) {
      if (tour.currentStep === this.steps.length - 1) tour.stop();

      tour.nextStep();
    },

    /**
     * При клике на кнопку, если есть заявки, то он перейдет на стр. 'leads-unprocessed'
     * Когда нет заявок, открывает модалки помощи
     */
    requestBtnOnclick() {
      this.$store.commit('help/POPUP_TOGGLE', true);
    },
  },
};
</script>
